import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { ItensPermission, Role, RolePermission } from "../interfaces/RolePermission";
import { ObjectUtil } from "../system-utils/utils/ObjectUtil";
import { UserAuthenticationServices } from "./user-authentication.services";

@Injectable({
    providedIn: 'root'
  })
  export class PermissionServices {
  
    constructor(private uas:UserAuthenticationServices) { }


    public canInsert:boolean = true;
    public canDelete:boolean = true;
    public canEdit:boolean = true;
    public canExport:boolean = false;
    public canConfig:boolean = false;
    public canView:boolean = false;
    public entityName:string;
    
    checkPermission(table:string):ItensPermission{
        
        if ( this.uas.user == null ){
            // this.canInsert = false;
            // this.canEdit = false;
            // this.canDelete = false;
            // this.canExport = false;
            // this.canConfig = false;
            // this.canView = false;
            return {
                function: table,
                canInsert: false,
                canEdit: false,
                canDelete: false,
                canExport: false,
                canConfig: false,
                canView: false
            }
        }else{
          
            for ( var p of this.uas.user.permission) {
                if ( ObjectUtil.isNotEmpty(p.ROLE)){
                  let role:Role  = JSON.parse(p.ROLE.toString()) as Role;
                  
                  if ( ObjectUtil.isNotEmpty(role.permission)){
                    if ( Array.isArray(role.permission)){
                      for ( var permission of role.permission) {
                        if (permission.function.toUpperCase() == table.toUpperCase()){
                            return permission;
                            // this.canInsert = permission.canInsert;
                            // this.canEdit = permission.canEdit;
                            // this.canDelete = permission.canDelete;
                            // this.canExport = permission.canExport;
                            // this.canView = permission.canView;
                            // this.canConfig = permission.canConfig;
                            // return;
                        }
                      }
                    }
                  }
                }
              }

        }
        
        return {
          function: table,
          canInsert: false,
          canEdit: false,
          canDelete: false,
          canExport: false,
          canConfig: false,
          canView: false
      }

    }


    checkActionPermission(id:number){
        let canExecuteAction = false;

        this.uas.user.permission.forEach((p:RolePermission)=>{
            if ( ObjectUtil.isNotEmpty(p.ROLE)){
              let role:Role  = JSON.parse(p.ROLE.toString()) as Role;
              
              if ( ObjectUtil.isNotEmpty(role.action)){
                  role.action.forEach(permission=>{
                      if ( permission == id){
                        canExecuteAction = true;
                        return;
                      }
                  })
              }
            }
        });

        return canExecuteAction;
    }
  

    checkPermissionSession(table:string, type:string):Boolean{

      let canExecute  = false;
      
      this.uas.user.permission.forEach((p:RolePermission)=>{
          if ( ObjectUtil.isNotEmpty(p.ROLE)){
            let role:Role  = JSON.parse(p.ROLE.toString()) as Role;
            
            if ( ObjectUtil.isNotEmpty(role.permission)){
              if ( Array.isArray(role.permission)){
                for ( var permission of role.permission){
                  
                  if (permission.function.toUpperCase() == table.toUpperCase()){
                    
                      this.canInsert = permission.canInsert;
                      if ( type == 'insert'){
                        canExecute = permission.canInsert;
                      }
                      if ( type == 'edit'){
                        canExecute = permission.canEdit;
                      }
                      if ( type == 'delete'){
                        canExecute = permission.canDelete;
                      }
                      if ( type == 'view'){
                        canExecute = permission.canView;
                      }

                      if ( type == 'export'){
                        canExecute = permission.canExport;
                      }
                      break;
                  }
                }
              }
            }
          }
      })

      return canExecute;
    }
  }  